import { createFileRoute } from '@tanstack/react-router';
import { Card } from '@osd/ui/card';
import { Stack } from '@osd/ui/stack';
import { Text } from '@osd/ui/text';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/card — live docs for the `Card` primitive.
 */
export const Route = createFileRoute('/ui/_layout/card')({
  component: CardPage,
});

function CardPage() {
  return (
    <Stack gap={6}>
      <Section title="Card" hint="composable surface — Header / Body / Footer subcomponents">
        <Stack gap={4}>
          <Card>
            <Card.Title>Header</Card.Title>
            <Card.Body>
              <Text>Body content goes here.</Text>
            </Card.Body>
          </Card>
          <Card>
            <Card.Body>Plain card — no header or footer.</Card.Body>
          </Card>
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Plain card — just a body"
            language="tsx"
            code={`<Card>
  <Card.Body>A simple card with no header or footer.</Card.Body>
</Card>`}
          />

          <CodeBlock
            title="With a title and body"
            language="tsx"
            code={`<Card>
  <Card.Title>Account settings</Card.Title>
  <Card.Body>
    <Text>Manage your email, password, and notifications.</Text>
  </Card.Body>
</Card>`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
